import { IUserState } from '../types';

export const CHANGE_USER = 'USER :: CHANGE';

export type TChangeUserAction = {
  type: typeof CHANGE_USER;
  payload: IUserState;
};

export function changeUser(payload: IUserState): TChangeUserAction {
  return {
    type: CHANGE_USER,
    payload,
  };
}
